export default __webpack_public_path__ + "static/media/0.07e46859.jpg";